module.exports = __webpack_public_path__ + "static/media/type-3.d723659a.svg";